'use client';

import { ShieldIcon, PlusIcon } from '@phosphor-icons/react';
import { useRouter } from '@/lib/router';
import { useFormatCurrency } from '@/hooks/useFormatCurrency';
import { Button } from '@/components/ui/button';

interface Props {
  averageMonthlyExpense: number;
}

export function ReservaSuggestion({ averageMonthlyExpense }: Props) {
  const router = useRouter();
  const formatCurrency = useFormatCurrency();
  const suggested = 6 * averageMonthlyExpense;

  return (
    <div className="rounded-[var(--radius-3xl)] border border-dashed border-border bg-surface shadow-[var(--shadow-1)] p-4">
      <div className="mb-3 flex items-start gap-3">
        <div className="grid size-10 shrink-0 place-items-center rounded-lg bg-success-surface text-success-text">
          <ShieldIcon size={18} weight="bold" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-text-primary">Comece pela sua reserva</div>
          <div className="mt-0.5 text-xs text-text-secondary">
            A base de qualquer planejamento. Recomendamos 6 meses das suas despesas médias —{' '}
            {suggested > 0 ? (
              <>
                <span className="font-mono text-text-primary">{formatCurrency(suggested)}</span>
                {' '}com base nos últimos 6 meses.
              </>
            ) : (
              <>conecte suas contas para ver uma sugestão personalizada.</>
            )}
          </div>
        </div>
      </div>
      <Button
        onClick={() => router.push('/metas/new?type=Reserve')}
        className="h-8 px-3 text-sm"
      >
        <PlusIcon size={14} weight="bold" className="mr-1" />
        Configurar reserva
      </Button>
    </div>
  );
}
